import React from 'react';
import PropTypes from 'prop-types';

const DownloadButton = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      role="img"
    >
      <title>Download Button</title>
      <g transform="translate(-1 -2)">
        <path
          fill={color}
          className="a"
          d="M22,12a1,1,0,0,0-1,1v7H3V13a1,1,0,1,0-2,0v8a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V13A1,1,0,0,0,22,12Z"
        />
        <path
          fill={color}
          className="a"
          d="M12,2a1,1,0,0,0-1,1V14.586L8.707,12.293a1,1,0,1,0-1.414,1.414l4,4a1,1,0,0,0,.325.216.986.986,0,0,0,.764,0,1,1,0,0,0,.325-.216l4-4a1,1,0,1,0-1.414-1.414L13,14.586V3A1,1,0,0,0,12,2Z"
        />
      </g>
    </svg>
  );
};

export default DownloadButton;

DownloadButton.propTypes = {
  color: PropTypes.string,
};
